import { Section } from '@web_opxp/components';
import { LanguageSelectors, StatsSelectors, useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { EDomain } from '../base/types';
import { IState } from '../store/state';
import { ATTENTION_DOMAIN_STAT, MEMORY_DOMAIN_STAT, REASONING_DOMAIN_STAT, SPEED_DOMAIN_STAT } from './constants';
import './DomainSection.scss';
import DomainSliderContainer, { IDomainPercent } from './DomainSliderContainer';
import { PersonalizationActions } from './slice';

interface IDomainSectionOwnProps {
  userId?: number;
}

export interface IDomainSectionFCProps extends IDomainSectionOwnProps {
  loaded: boolean;
  data: IDomainPercent[];
  onSaveDomainStat: typeof PersonalizationActions.savePersonalizationDomainStat;
}

export const DomainSectionFC: React.FC<IDomainSectionFCProps> = ({ loaded, data, onSaveDomainStat, userId }) => {
  const { t } = useTranslation();
  const saveDomainHandler = (domain: EDomain, stat: number) => onSaveDomainStat(domain, stat, userId);

  return (
    <Section className="domain-section">
      <div className="row">
        <div className="title col-4">
          <h3>{t('Personalization.DomainSection.Title')}</h3>
        </div>
        <div className="content col-8">
          <p>{t('Personalization.DomainSection.Description')}</p>
        </div>
      </div>
      {data.map((element) => (
        <DomainSliderContainer
          key={`${element.domain}-${element.percent}`}
          data={element}
          sliderVisible={loaded}
          onChange={saveDomainHandler}
        />
      ))}
    </Section>
  );
};

const mapStateToProps = (state: IState, ownProps: IDomainSectionOwnProps) => {
  const { userId } = ownProps;
  const langLoaded = !LanguageSelectors.isLoading(state);
  const statsLoaded = !StatsSelectors.isStatsLoading(state);
  const speedDomainPercent = StatsSelectors.getStatIntValueById(state, SPEED_DOMAIN_STAT, userId);
  const reasoningDomainPercent = StatsSelectors.getStatIntValueById(state, REASONING_DOMAIN_STAT, userId);
  const attentionDomainPercent = StatsSelectors.getStatIntValueById(state, ATTENTION_DOMAIN_STAT, userId);
  const memoryDomainPercent = StatsSelectors.getStatIntValueById(state, MEMORY_DOMAIN_STAT, userId);
  const data: IDomainPercent[] = [
    {
      domain: EDomain.Memory,
      percent: memoryDomainPercent ?? 0,
    },
    {
      domain: EDomain.Attention,
      percent: attentionDomainPercent ?? 0,
    },
    {
      domain: EDomain.Reasoning,
      percent: reasoningDomainPercent ?? 0,
    },
    {
      domain: EDomain.Speed,
      percent: speedDomainPercent ?? 0,
    },
  ];

  return {
    loaded: statsLoaded && langLoaded,
    data,
  };
};

const mapDispatchToProps = {
  onSaveDomainStat: PersonalizationActions.savePersonalizationDomainStat,
};

const DomainSection = connect(mapStateToProps, mapDispatchToProps)(DomainSectionFC);

export default DomainSection;
